var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7652 20.8117V8.63774C25.7652 6.15005 23.7668 4.13339 21.3017 4.13339C18.8366 4.13339 16.8382 6.15005 16.8382 8.63774V12.8237L15.2699 10.7307V8.63774C15.2699 5.276 17.9704 2.55078 21.3017 2.55078C24.6329 2.55078 27.3334 5.276 27.3334 8.63774V20.8117C27.3334 25.5181 23.5527 29.3334 18.889 29.3334H11.6509L13.7041 27.7508H18.889C22.6866 27.7508 25.7652 24.644 25.7652 20.8117Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6508 27.7505C16.1147 27.7505 19.7333 24.0987 19.7333 19.594C19.7333 15.0893 16.1147 11.4375 11.6508 11.4375C7.18693 11.4375 3.56825 15.0893 3.56825 19.594C3.56825 24.0987 7.18693 27.7505 11.6508 27.7505ZM11.6508 29.3331C16.9808 29.3331 21.3016 24.9728 21.3016 19.594C21.3016 14.2152 16.9808 9.85486 11.6508 9.85486C6.32081 9.85486 2 14.2152 2 19.594C2 24.9728 6.32081 29.3331 11.6508 29.3331Z",
    fill: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6506 22.8811C13.4495 22.8811 14.9077 21.4095 14.9077 19.5942C14.9077 17.7788 13.4495 16.3072 11.6506 16.3072C9.85172 16.3072 8.39345 17.7788 8.39345 19.5942C8.39345 21.4095 9.85172 22.8811 11.6506 22.8811ZM11.6506 24.4637C14.3156 24.4637 16.476 22.2836 16.476 19.5942C16.476 16.9048 14.3156 14.7246 11.6506 14.7246C8.9856 14.7246 6.8252 16.9048 6.8252 19.5942C6.8252 22.2836 8.9856 24.4637 11.6506 24.4637Z",
    fill: "#263238"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6507 20.8117C12.3169 20.8117 12.857 20.2667 12.857 19.5943C12.857 18.922 12.3169 18.377 11.6507 18.377C10.9844 18.377 10.4443 18.922 10.4443 19.5943C10.4443 20.2667 10.9844 20.8117 11.6507 20.8117Z",
    fill: "#263238"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6826 2.1407C17.6826 1.69482 18.0408 1.33337 18.4826 1.33337C18.9244 1.33337 19.2826 1.69482 19.2826 2.1407V4.56267H17.6826V2.1407Z",
    fill: "#263238"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 7.33329C18.6665 6.9651 18.965 6.66663 19.3332 6.66663C19.7014 6.66663 19.9998 6.9651 19.9998 7.33329C19.9998 7.70148 19.7014 7.99996 19.3332 7.99996C18.965 7.99996 18.6665 7.70148 18.6665 7.33329Z",
    fill: "#263238"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7144 2.1407C23.7144 1.69482 24.0725 1.33337 24.5144 1.33337C24.9562 1.33337 25.3144 1.69482 25.3144 2.1407V4.56266H23.7144V2.1407Z",
    fill: "#263238"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2002 7.33329C23.2002 6.9651 23.4987 6.66663 23.8669 6.66663C24.2351 6.66663 24.5335 6.9651 24.5335 7.33329C24.5335 7.70148 24.2351 7.99996 23.8669 7.99996C23.4987 7.99996 23.2002 7.70148 23.2002 7.33329Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnail);
export default __webpack_public_path__ + "static/media/snail.f0bd0ffead9a450e2d40d5a87702b751.svg";
export { ForwardRef as ReactComponent };